<template>
  <gru-table
          :resource="resource"
          :fields="fields"
          :enabledExcel="false"
          :enabledPrint="false"
          :primaryKey="'id'"
          :hiddenC="hiddenC"
  ></gru-table>
</template>

<script>
  import { userContants } from "@/constants";
  export default {
    name: "NotificationProfileList",
    data() {
      return {
        resource: "notification",
        hiddenC: [
          {
            columnName: "sender",
            columnType: "STRING",
            value: this.$store.state.auth.user.username
          }
        ],
        optionValues: ["SMS", "Email"]
      };
    },
    computed: {
      fields() {
        return [
          {
            text: "lang.notification.title",
            value: "title",
            sortable: true,
            editable: true
          },
          {
            text: "lang.notification.description",
            value: "description",
          },
          {
            text: "lang.notification.type",
            value: "type",
            optionValues: this.optionValues,
          },
          {
            text: "lang.notification.status",
            value: "status",
            optionValues: userContants.allStateTypes,
            columnType: "BOOLEAN"
          },

        ];
      }
    }
  };
</script>

<style scoped></style>
